export class Values {
  constructor() {
    this.initValuesButtons();
    this.initValuesHeadings();
  }
  initValuesButtons() {
    const btns = document.querySelectorAll('._values-item.style-03 .btn');
    const icons = document.querySelectorAll('._values-item.style-03 .btn .button-icon');
    const lists = document.querySelectorAll('._values-item.style-03 .text ul');

    btns.forEach((el, id) => {
      el.addEventListener('click', e => {
        e.preventDefault();

        el.classList.toggle('active');

        if (el.classList.contains('active')) {
          el.style.paddingBottom = getComputedStyle(lists[id]).height;
        } else {
          el.style.paddingBottom = null;
        }

        icons[id].classList.toggle('active');
      });
    });
  }

  onClassChange(element, callback) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          callback(mutation.target);
        }
      });
    });
    observer.observe(element, { attributes: true });
    return observer.disconnect;
  }

  initValuesHeadings() {
    const headings = document.querySelectorAll('._values-item.style-04 .heading');
    const texts = document.querySelectorAll('._values-item.style-04 .text');

    const tabs = document.querySelectorAll('.vc_tta-tab.vc_active');

    tabs.forEach((tab, id) => {
      this.onClassChange(tab, function() {
        headings.forEach((el, id) => {
          if (headings[id].checkVisibility()) {
            texts[id].style.marginTop = getComputedStyle(headings[id]).height;
          }
        });
      });
    })


    headings.forEach((el, id) => {
      if(headings[id].checkVisibility()) {
        texts[id].style.marginTop = getComputedStyle(headings[id]).height;
      }

      el.addEventListener('click', e => {
        e.preventDefault();

        el.classList.toggle('active');

        if (el.classList.contains('active')) {
          el.style.marginBottom = getComputedStyle(texts[id]).height;
        } else {
          el.style.marginBottom = null;
        }
      });
    });
  }
}

export default new Values;
